// DS7.4.1, but only a button.
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import GhostButton from '../../../Buttons/GhostButton';
import s from './BannerButton.scss';
/**
 * DS7.4.1, but only a button.
 *
 * A helper component with some typescript guidance to keep our banner buttons somewhat similar. Use this in tandem with other
 * {@link @wix/da-ds/pkg/Banner/lego} components when building a variant of DS7.4.1
 */ const BannerButton = (_param)=>{
    var { variant, className, children } = _param, rest = _object_without_properties(_param, [
        "variant",
        "className",
        "children"
    ]);
    switch(variant){
        case 'ghost':
            return /*#__PURE__*/ React.createElement(GhostButton, _object_spread({
                size: "small",
                variant: "main",
                className: className
            }, rest), children);
        case 'underline':
        default:
            return /*#__PURE__*/ React.createElement(PlainButtonOrLink, _object_spread({
                className: c(s['text-link'], className)
            }, rest), children);
    }
};
BannerButton.displayName = 'BannerButton';
export default BannerButton;

//# sourceMappingURL=BannerButton.js.map